import ProfitAndLossReportView from '@/proflos/ProfitAndLossReportView.vue'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {registerRoute} from '@/router'
import {registerHotkey} from '@/hotkeys/navigationHotkeys'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'

export const PROFIT_AND_LOSS = {componentName: 'ProfLos', component: ProfitAndLossReportView, meta: {requiresOrg: true}}
const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()
const icon = 'i-ph-chart-bar-fill'
const label = 'Resultatrapport'
const hotkey = 'u'
const route = PROFIT_AND_LOSS

registerNavigationCommand({
    route,
    label,
    icon,
    hotkey
})
registerNavigationEntry(NavGroup.REPORTS, {
    title: label,
    key: 'profit-and-loss',
    icon,
    target: route,
    sortOrder: 5
})

registerRoute(route)
registerHotkey(hotkey, PROFIT_AND_LOSS)
buildSimpleCrumb(PROFIT_AND_LOSS, label, icon, true)